/**
 * Upgrade Modal Store – Toon "Upgrade vereist" bij 403 Forbidden
 * API interceptor triggert deze store; App toont de modal.
 */

import { create } from 'zustand'

export const useUpgradeModalStore = create((set) => ({
  isOpen: false,
  message: null,
  show: (message) => set({ isOpen: true, message: message || 'Deze functie vereist een upgrade van uw abonnement.' }),
  hide: () => set({ isOpen: false, message: null }),
}))
